import { Browser, isNullOrUndefined as isNOU } from '@syncfusion/ej2-base';
import { getScrollableParent } from '@syncfusion/ej2-popups';
import * as events from '../base/constant';
import * as classes from '../base/classes';
import { addClass, removeClass } from '@syncfusion/ej2-base';
/**
 * `FullScreen` module is used to maximize and minimize screen
 */
var FullScreen = /** @class */ (function () {
    function FullScreen(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    /**
     * showFullScreen method
     * @hidden
     * @deprecated
     */
    FullScreen.prototype.showFullScreen = function (event) {
        if (this.parent.toolbarSettings.enable === true && this.parent.editorMode !== 'Markdown'
            && !isNOU(this.parent.quickToolbarModule)) {
            this.parent.quickToolbarModule.hideQuickToolbars();
        }
        this.scrollableParent = getScrollableParent(this.parent.element);
        if (!this.parent.element.classList.contains(classes.CLS_FULL_SCREEN)) {
            this.parent.trigger(events.actionBegin, { requestType: 'Maximize', targetItem: 'Maximize', args: event });
            if (this.parent.toolbarSettings.enableFloating &&
                !this.parent.inlineMode.enable && this.parent.toolbarSettings.enable) {
                this.parent.getToolbarElement().style.width = '100%';
                this.parent.getToolbarElement().style.top = '0px';
            }
            this.parent.element.classList.add(classes.CLS_FULL_SCREEN);
            this.toggleParentOverflow(true);
            this.parent.setContentHeight();
            if (this.parent.toolbarModule) {
                if (!this.parent.getBaseToolbarObject().toolbarObj.items[0].properties) {
                    this.parent.getBaseToolbarObject().toolbarObj.removeItems(0);
                }
                if (Browser.isDevice) {
                    this.parent.toolbarModule.removeFixedTBarClass();
                }
                this.parent.toolbarModule.updateItem({
                    targetItem: 'Maximize',
                    updateItem: 'Minimize',
                    baseToolbar: this.parent.getBaseToolbarObject()
                });
            }
            this.parent.trigger(events.actionComplete, { requestType: 'Maximize', targetItem: 'Maximize', args: event });
        }
    };
    /**
     * hideFullScreen method
     * @hidden
     * @deprecated
     */
    FullScreen.prototype.hideFullScreen = function (event) {
        if (this.parent.toolbarSettings.enable === true && this.parent.editorMode !== 'Markdown'
            && !isNOU(this.parent.quickToolbarModule)) {
            this.parent.quickToolbarModule.hideQuickToolbars();
        }
        if (this.parent.element.classList.contains(classes.CLS_FULL_SCREEN)) {
            this.parent.element.classList.remove(classes.CLS_FULL_SCREEN);
            var elem = document.querySelectorAll('.e-rte-overflow');
            for (var i = 0; i < elem.length; i++) {
                removeClass([elem[i]], ['e-rte-overflow']);
            }
            this.parent.trigger(events.actionBegin, { requestType: 'Minimize', targetItem: 'Minimize', args: event });
            this.parent.setContentHeight();
            if (this.parent.toolbarModule) {
                if (!this.parent.getBaseToolbarObject().toolbarObj.items[0].properties) {
                    this.parent.getBaseToolbarObject().toolbarObj.removeItems(0);
                }
                this.parent.toolbarModule.updateItem({
                    targetItem: 'Minimize',
                    updateItem: 'Maximize',
                    baseToolbar: this.parent.getBaseToolbarObject()
                });
                if (Browser.isDevice && this.parent.inlineMode.enable) {
                    this.parent.toolbarModule.addFixedTBarClass();
                }
            }
            this.parent.trigger(events.actionComplete, { requestType: 'Minimize', targetItem: 'Minimize', args: event });
        }
    };
    FullScreen.prototype.toggleParentOverflow = function (isAdd) {
        if (isNOU(this.scrollableParent)) {
            return;
        }
        for (var i = 0; i < this.scrollableParent.length; i++) {
            if (this.scrollableParent[i].nodeName === '#document') {
                var elem = document.querySelector('body');
                addClass([elem], ['e-rte-overflow']);
            }
            else {
                var elem = this.scrollableParent[i];
                addClass([elem], ['e-rte-overflow']);
            }
        }
    };
    FullScreen.prototype.onKeyDown = function (event) {
        var originalEvent = event.args;
        switch (originalEvent.action) {
            case 'full-screen':
                this.showFullScreen(event.args);
                originalEvent.preventDefault();
                break;
            case 'escape':
                this.hideFullScreen(event.args);
                originalEvent.preventDefault();
                break;
        }
    };
    FullScreen.prototype.addEventListener = function () {
        this.parent.on(events.keyDown, this.onKeyDown, this);
        this.parent.on(events.destroy, this.destroy, this);
    };
    FullScreen.prototype.removeEventListener = function () {
        this.parent.off(events.keyDown, this.onKeyDown);
        this.parent.off(events.destroy, this.destroy);
    };
    /**
     * destroy method
     * @hidden
     * @deprecated
     */
    FullScreen.prototype.destroy = function () {
        if (this.parent.element.classList.contains(classes.CLS_FULL_SCREEN)) {
            this.toggleParentOverflow(false);
        }
        var elem = document.querySelectorAll('.e-rte-overflow');
        for (var i = 0; i < elem.length; i++) {
            removeClass([elem[i]], ['e-rte-overflow']);
        }
        this.removeEventListener();
    };
    return FullScreen;
}());
export { FullScreen };
